module.exports = __webpack_public_path__ + "img/bgtop.5627559e.png";